import {useAvatarImages} from "../data/hooks/avatar-images";
import {Bold, Heading2, Paragraph} from "../style/itf-styled-components";
import Img from "gatsby-image/withIEPolyfill";
import React from "react";

export const MembersAvatarList = ({speakers}) => {
  const avatarImages = useAvatarImages();

  return (
    <>
      {!!speakers.length && (
        <div>
          <Heading2 css={`color: ${props => props.theme.colors.secondary._500};`}>Speakeri</Heading2>
          <div
            css={`
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              padding-top: 25px;
            `}
          >
            {
              speakers.map((speaker, index) => (
                [avatarImages.find(avatarImage => avatarImage.name === speaker.slug)]
                  .filter(Boolean)
                  .map(avatarImage =>
                    <div
                      css={`
                        padding: 10px;
                        width: 250px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        
                        @media (max-width: ${props => props.theme.mobileWidth}) {
                          width: 190px;
                        }
                      `}
                      key={index}
                    >
                      <Img
                        css={`
                          width: 120px;
                        `}
                        fluid={avatarImage.childImageSharp.fluid}
                        objectPosition="50% top"
                      />
                      <Paragraph><Bold>{speaker.name}</Bold></Paragraph>
                      {speaker.style && (<i>{speaker.style}</i>)}
                    </div>)
              ))
            }
          </div>
        </div>)}
    </>
  );
}